import { render, staticRenderFns } from "./Speak.vue?vue&type=template&id=cc81a328&"
import script from "./Speak.vue?vue&type=script&lang=js&"
export * from "./Speak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports